import React, { useEffect, useState } from 'react';
import { Grid, pn, useElementBreakpoints } from '@compass/core';
import { Select } from 'components';
import {
    StudentFilter as StudentFilterModel,
    StudentFilterResource,
    LkStudentDisplayFilterId,
} from 'generated/openApi';
import { useServiceData } from '../contexts/ServiceDataContext';
import ApiService from 'services/apiService';


export const ServiceFilterControls = () => {
    const { breakpointsRef, smallFieldBreakpoints } = useElementBreakpoints();
    const { filter, updateFilter } = useServiceData();

    // Fetch StudentFilterResource for program filter
    const [resource, setResource] = useState<StudentFilterResource>({} as StudentFilterResource);
    const properties = resource.properties || [];

    useEffect(() => {
        ApiService.students.getFilterResource().then((response) => {
            setResource(response);
        });
    }, []);

    const programField = () => {
        const propertyName = pn<StudentFilterModel>("programIds");
        const property = properties.find((x) => x.propertyName === propertyName);

        return (
            <Select
                modelProperty={property}
                value={resource.programs?.find((x) => x.id === filter.programId)}
                options={resource.programs}
                getOptionLabel={(option) => option.name}
                onChange={(e, value) => updateFilter({ programId: value?.id ?? null })}
            />
        );
    };

    // Check if tenant should see the program filter
    const showProgramFilter = resource.displayFilters?.some(
        x => x.id === LkStudentDisplayFilterId.Program
    );

    // Don't render anything if program filter shouldn't be shown
    if (!showProgramFilter) {
        return null;
    }

    return (
        <Grid ref={breakpointsRef} container spacing="sm" sx={{ maxWidth: 200 }}>
            <Grid item xs={smallFieldBreakpoints}>
                {programField()}
            </Grid>
        </Grid>
    );
};